import React from 'react';
import DashboardCard from '../shared/DashboardCard';
import EmptyState from '../shared/EmptyState';
import styles from '../../../../styles/DashboardV2.module.css';

type ExpiredDocument = {
    id: string;
    name: string;
    expiryDate: string;
    documentId?: string;
    type: any;
}

interface ExpiredDocumentsWidgetProps {
    documents: ExpiredDocument[];
    onUploadRenewal?: (doc: ExpiredDocument) => void;
    loading?: boolean;
}

const getDaysAgo = (dateStr: string): string => {
    const now = new Date();
    const exp = new Date(dateStr);
    const diff = Math.floor((now.getTime() - exp.getTime()) / (1000 * 60 * 60 * 24));
    if (diff === 0) return 'Expired today';
    if (diff === 1) return 'Expired yesterday';
    return `Expired ${diff} days ago`;
};

const ExpiredDocumentsWidget: React.FC<ExpiredDocumentsWidgetProps> = ({
    documents,
    onUploadRenewal,
    loading,
}) => {
    const top5 = documents.slice(0, 5);

    return (
        <DashboardCard
            title="Expired Documents"
            loading={loading}
        >
            {top5.length === 0 ? (
                <EmptyState icon="✅" message="No expired documents." />
            ) : (
                <div className={styles.itemList}>
                    {top5.map(doc => (
                        <div key={doc.id} className={styles.listItem}>
                            <div className={`${styles.listItemDot} ${styles.dotRed}`} />
                            <div className={styles.listItemContent}>
                                <div className={styles.listItemTitle}>{doc.name}</div>
                                <div className={styles.listItemMeta} style={{ color: 'blue' }}>
                                    {doc.type?.name}
                                </div>
                                <div className={styles.listItemMeta} style={{ color: '#dc2626' }}>
                                    {getDaysAgo(doc.expiryDate)}
                                </div>
                            </div>
                            {onUploadRenewal && (
                                <button
                                    className={styles.listItemAction}
                                    onClick={() => onUploadRenewal(doc)}
                                >
                                    Renew
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </DashboardCard>
    );
};

export default ExpiredDocumentsWidget;
